const rows = [
  { feature: "Processing Time", fpc: "2–9 business days", diy: "3–11 weeks", agency: "Same day (emergency only)" },
  { feature: "Agency Appointment", fpc: "Not required", diy: "Required (Denver only)", agency: "Required" },
  { feature: "Document Review", fpc: "Dedicated agent checks all docs", diy: "You review yourself", agency: "No pre-review" },
  { feature: "Status Updates", fpc: "Daily via phone or email", diy: "USPS tracking only", agency: "No updates" },
  { feature: "Nearest Agency", fpc: "We handle submission remotely", diy: "Denver — 360+ miles", agency: "Denver — 360+ miles" },
  { feature: "Error Protection", fpc: "Agent catches mistakes before submission", diy: "Errors cause weeks of delay", agency: "Errors cause rejection" },
  { feature: "Government Shutdowns", fpc: "Not affected", diy: "Delays likely", agency: "Closes entirely" },
  { feature: "Cost", fpc: "Service fee + government fee", diy: "Government fee only", agency: "Government fee + travel" },
  { feature: "Money-Back Guarantee", fpc: "Included — no additional cost", diy: "None", agency: "None" },
];

export default function ComparisonSection() {
  return (
    <section id="comparison" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Side by Side</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. DIY vs. Regional Agency
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            For Rapid City residents, the nearest passport agency is Denver — over 360 miles away via I-90 and I-25. Here is how your options really stack up.
          </p>
        </div>

        <div className="mb-8 bg-amber-50 border border-[#F6C344]/40 rounded-lg p-6">
          <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">
            Rapid City Passport Agency Appointment Not Available?
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Regional passport agency appointments are routinely booked 2–4 weeks out — and walk-ins are never accepted. If you searched for an appointment and came up empty, Fast Passport Center&apos;s registered courier channel is your fastest next step. No appointment. No waiting in line at the federal building. Processing as fast as 2–3 business days.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="overflow-x-auto rounded-lg border border-gray-200">
          <table className="w-full min-w-[640px]">
            <thead>
              <tr className="bg-[#1A365D] text-white">
                <th className="text-left px-5 py-4 text-sm font-bold">Feature</th>
                <th className="px-5 py-4 text-sm font-bold text-center text-[#F6C344]">Fast Passport Center</th>
                <th className="px-5 py-4 text-sm font-bold text-center">DIY Post Office</th>
                <th className="px-5 py-4 text-sm font-bold text-center">Regional Agency</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]"}>
                  <td className="px-5 py-3.5 text-sm font-semibold text-[#1A365D]">{row.feature}</td>
                  <td className="px-5 py-3.5 text-sm text-center text-green-700 font-medium">
                    <i className="ri-check-line text-green-500 mr-1.5"></i>{row.fpc}
                  </td>
                  <td className="px-5 py-3.5 text-sm text-center text-gray-500">{row.diy}</td>
                  <td className="px-5 py-3.5 text-sm text-center text-gray-500">{row.agency}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started — No Denver Trip Needed <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}